import { render, staticRenderFns } from "./Index4.vue?vue&type=template&id=584aee68"
import script from "./Index4.vue?vue&type=script&lang=js"
export * from "./Index4.vue?vue&type=script&lang=js"
import style0 from "./Index4.vue?vue&type=style&index=0&id=584aee68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports